import React from 'react';

var SettingRow = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-setting-row' }, children);
};

export { SettingRow };
